import * as Sentry from '@sentry/react';

export const logError: typeof Sentry.captureException = (...params) =>
  Sentry.captureException(...params);
